<template>
    <div>
        <b-row>
    <b-col cols="12">
        <div class="animated fadeIn">
          <b-row>
            <b-col sm="12">
                <Vuetable
                        class="table table-striped table-bordered nowrap vue-tbl"
                        ref="usertable"
                        :api-url="getUrl"
                        :http-options="httpOptions"
                        :fields="fields"
                        pagination-path
                        @vuetable:pagination-data="onPaginationData"
                        :append-params="moreParams"
                        :per-page="perPage">
                    <template slot="actions" scope="props">
                        <div class="custom-actions">
                            <b-button
                                    class="btn btn-success btn-sm"
                                    @click="onActionClicked('view-item', props.rowData, props.rowIndex)"
                            >
                                <i class="cui-user-follow"></i>View
                            </b-button> |
                            <b-button
                                    class="btn btn-warning btn-sm"
                                    @click="onActionClicked('edit-item', props.rowData, props.rowIndex,true)"
                            >
                                <i class="cui-user-follow"></i>Edit
                            </b-button>
                        </div>
                    </template>
                </vuetable>

                <b-row>
                    <b-col>
                        <div class="pagination">
                            <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
          </b-row>
        </div>
    </b-col>
  </b-row>
    </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";

export default {
  name: 'tables',
  components: {
      Vuetable,
      VuetablePagination
  },
    data(){
        return {
            httpOptions: {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                },
                data: {}
            },
            moreParams: {},
            getUrl: process.env.VUE_APP_API_ENDPOINT + "users",
            fields: [
                {
                    name: "id",
                    title: '<span class="orange glyphicon glyphicon-user"></span> #',
                    sortField: "id"
                },
                {
                    name: "user_name",
                    title: '<span class="orange glyphicon glyphicon-user"></span> Log Name',
                    sortField: "user_name"
                },
                {
                    name: "full_name",
                    title:
                        '<span class="orange glyphicon glyphicon-user"></span> Description',
                    sortField: "full_name"
                },
                {
                    name: "email",
                    title:
                        '<span class="orange glyphicon glyphicon-user"></span> Causer',
                    sortField: "email"
                },
                {
                    name: "first_name",
                    title:
                        '<span class="orange glyphicon glyphicon-user"></span> Timestamp',
                    sortField: "first_name"
                },
                {
                    name: "active",
                    title: '<span class="orange glyphicon glyphicon-user"></span> IP',
                    sortField: "first_name"
                },
                {
                    name: "roles",
                    title:
                        '<span class="orange glyphicon glyphicon-user"></span> Origin',
                    sortField: "first_name",
                    callback: 'getRoles'
                },
                {
                    name: "updated_at",
                    title: '<span class="orange glyphicon glyphicon-user"></span> Properties',
                    sortField: "updated_at"
                }
                ,"__slot:actions",

            ],
            data: [],
            perPage: 3,
            sortOrder: [],
            filterText: ""
        }
    },
    methods:{
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },  onChangePage(page) {
            this.$refs.usertable.changePage(page);
        },
        onFilterSet(filters) {
            this.moreParams = {
                user_id: filters.user_id,
                user_name: filters.user_name,
                user_role: filters.user_role,
                company: filters.company,
                email: filters.email
            };
             Vue.nextTick(() => this.$refs.usertable.refresh());
        },
        onFilterReset() {
             Vue.nextTick(() => this.$refs.usertable.refresh());
        },
        getFullName(roles){
            let str = '';
            roles.forEach(function(role, index) {
                str += role.name;
                if (index != (roles.length - 1)) {
                    str += ',';
                };
            });
            return str;
        },

        getRoles(roles){
            let str = '';
            roles.forEach(function(role, index) {
                str += role.name;
                if (index != (roles.length - 1)) {
                    str += ',';
                };
            });
            return str;
        },
        onActionClicked(action, data, rowIndex, pdf = false) {
            if(action == 'edit-item'){
                this.$router.push({
                    name: "UserEdit",
                    params: {
                        user_id: data.id
                    }
                });
            }else if(action == 'view-item'){
                this.$router.push({
                    name: "User",
                    params: {
                        id: data.id
                    }
                });
            }
        },
    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.usertable.refresh();
        }
    },

    mounted() {
        this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
        this.$events.$on("filter-reset", e => this.onFilterReset());
    },
}
</script>

<style scoped>

.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}


</style>